/* TRW Armory cart checkout acknowledgment
   Delegated listeners remain active when Shopify re-renders the cart drawer. */
(() => {
  if (window.__trwCheckoutDisclosureReady) return;
  window.__trwCheckoutDisclosureReady = true;

  const closest = (target, selector) =>
    target instanceof Element ? target.closest(selector) : null;

  document.addEventListener('click', (event) => {
    const openButton = closest(event.target, '[data-trw-disclosure-open]');
    if (openButton) {
      event.preventDefault();
      if (openButton.disabled) return;

      const root = openButton.closest('.cart__ctas');
      const dialog = root?.querySelector('[data-trw-disclosure-dialog]');
      if (!dialog) {
        window.alert('Checkout notice is temporarily unavailable. Please refresh the page and try again.');
        return;
      }

      if (!dialog.open) {
        try {
          dialog.showModal();
        } catch (_error) {
          // Fallback for browsers that reject nested modal dialogs.
          dialog.setAttribute('open', '');
          dialog.scrollIntoView({ block: 'center' });
        }
      }
      return;
    }

    const closeButton = closest(event.target, '[data-trw-disclosure-close]');
    if (closeButton) {
      event.preventDefault();
      const dialog = closeButton.closest('[data-trw-disclosure-dialog]');
      if (dialog?.close) dialog.close();
      else dialog?.removeAttribute('open');
      return;
    }

    const confirm = closest(event.target, '[data-trw-disclosure-confirm]');
    if (!confirm) return;
    event.preventDefault();

    const root = confirm.closest('.cart__ctas');
    const ack = root?.querySelector('[data-trw-disclosure-ack]');
    const err = root?.querySelector('[data-trw-ack-error]');
    if (!ack?.checked || confirm.dataset.trwBusy === 'true') return;

    confirm.dataset.trwBusy = 'true';
    confirm.disabled = true;
    const previousLabel = confirm.textContent;
    confirm.textContent = 'Opening secure checkout…';
    if (err) err.hidden = true;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 8000);
    const shopRoot = window.Shopify?.routes?.root || '/';
    const path = shopRoot.endsWith('/') ? shopRoot : shopRoot + '/';

    (async () => {
      try {
        const response = await fetch(path + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          signal: controller.signal,
          body: JSON.stringify({
            attributes: {
              'TRW International Armor Terms': 'Acknowledged',
              'TRW Terms Acknowledged At': new Date().toISOString()
            }
          })
        });

        if (!response.ok) throw new Error('Could not save acknowledgment');
        window.location.assign(path + 'checkout');
      } catch (_error) {
        confirm.disabled = false;
        confirm.dataset.trwBusy = 'false';
        confirm.textContent = previousLabel;
        if (err) {
          err.textContent = 'We could not save your acknowledgment. Please try again.';
          err.hidden = false;
        }
      } finally {
        clearTimeout(timeoutId);
      }
    })();
  }, true);

  document.addEventListener('change', (event) => {
    const ack = closest(event.target, '[data-trw-disclosure-ack]');
    if (!ack) return;
    const root = ack.closest('.cart__ctas');
    const confirm = root?.querySelector('[data-trw-disclosure-confirm]');
    const err = root?.querySelector('[data-trw-ack-error]');
    if (confirm && confirm.dataset.trwBusy !== 'true') confirm.disabled = !ack.checked;
    if (err) err.hidden = true;
  }, true);
})();